// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileTermsOfService_root__ymtq0","lastUpdated":"MobileTermsOfService_lastUpdated__2TU6R","disc":"MobileTermsOfService_disc__RhXNP"};